import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class App {
  protected readonly title = signal('shl-app');

  constructor(private readonly languageService: LanguageService) {
    this.languageService.initLanguage();
  }
}
